export const APP = {
  SESSION: "PHPSESSID",
}
